import { render, staticRenderFns } from "./ZztTixianModal__Style#Drawer.vue?vue&type=template&id=2aa2e85a&scoped=true&"
import script from "./ZztTixianModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ZztTixianModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ZztTixianModal__Style#Drawer.vue?vue&type=style&index=0&id=2aa2e85a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2e85a",
  null
  
)

export default component.exports